import React from "react";

const base =
  "inline-flex items-center justify-center gap-2 rounded-lg border text-sm transition-all duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-black/30 dark:focus-visible:ring-white/40";

const sizes = {
  md: "px-3 py-1",
};

const variants = {
  // Raised, pillowy 3D surface: top highlight + inner bottom shadow + drop
  // shadow give it depth, and it presses down on click. Tuned per theme.
  surface: [
    // Light theme
    "border-black/10 bg-gradient-to-b from-white to-neutral-200 text-neutral-900",
    "shadow-[inset_0_0.5px_0_0_rgba(255,255,255,0.9),inset_0_-2px_3px_0_rgba(0,0,0,0.1),0_2px_4px_-1px_rgba(0,0,0,0.16),0_7px_14px_-4px_rgba(0,0,0,0.14)]",
    "hover:from-neutral-50 hover:to-neutral-300 hover:border-black/20",
    "active:translate-y-px active:from-neutral-200 active:to-neutral-300 active:shadow-[inset_0_2px_4px_0_rgba(0,0,0,0.16)]",
    // Dark theme
    "dark:border-white/10 dark:from-neutral-900 dark:to-neutral-800 dark:text-white",
    "dark:shadow-[inset_0_0.5px_0_0_rgba(255,255,255,0.14),inset_0_-2px_3px_0_rgba(0,0,0,0.55),0_3px_5px_-1px_rgba(0,0,0,0.6),0_7px_14px_-4px_rgba(0,0,0,0.55)]",
    "dark:hover:from-neutral-900 dark:hover:to-neutral-700 dark:hover:border-white/20",
    "dark:active:from-neutral-800 dark:active:to-neutral-900 dark:active:shadow-[inset_0_2px_4px_0_rgba(0,0,0,0.6),inset_0_1px_0_0_rgba(255,255,255,0.06)]",
  ].join(" "),
};

/**
 * Renders an anchor styled as a button. External links automatically get
 * the correct rel/target attributes.
 */
export default function Button({
  children,
  href,
  external = false,
  size = "md",
  variant = "surface",
  className = "",
  ...props
}) {
  const externalProps = external
    ? { target: "_blank", rel: "noopener noreferrer" }
    : {};

  return (
    <a
      href={href}
      className={`${base} ${sizes[size]} ${variants[variant]} ${className}`}
      {...externalProps}
      {...props}
    >
      {children}
    </a>
  );
}
